module.exports = __webpack_public_path__ + "static/img/icon_cal.9ce9b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_cal.png
// module id = csM/
// module chunks = 1